import React from 'react';
import { topBar } from '../data/soklar';

// Honest top bar: no countdown, no fake scarcity (introduktionspris + engångsbetalning + 7 dagars garanti).
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="2vejxmgnua05h">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs font-medium sm:text-sm" data-id="element-57" data-mp="2re01ngf052kx">
        <span className="hidden sm:inline" data-id="element-58" data-mp="2mfyhst9r4z8e">{topBar.long}</span>
        <span className="sm:hidden" data-id="element-59" data-mp="2hf11ync7sha2">{topBar.short}</span>
      </div>
    </div>;
}